import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
// Inter, self-hosted: the @font-face rules of the app's typeface.
import './fonts.css';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
